<button
  mat-menu-item
  class="dropdown-menu-item"
  [ngClass]="{'disabled': disabled,
              'text-blue-hover': !disabled}"
>
  @if (icon) {
    @if (!isMaterialIcon) {
      <i
        [ngClass]="icon"
      ></i>
    }
    @else {
      <mat-icon>
        {{ icon }}
      </mat-icon>
    }
  }

  <span class="light">
    {{ text | translate }}
  </span>
</button>
